import { render } from "./DMETableRow.vue?vue&type=template&id=3d08a062&ts=true"
import script from "./DMETableRow.ts?vue&type=script&lang=ts&external"
export * from "./DMETableRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__